// src/libs/hooks/useSelectImg.ts
type ImageFormat = string | undefined;

const defaultImg: ImageFormat = '/img/default-image.jpg'; // Assurez-vous que c'est un chemin valide

// Fonction pour choisir l'image appropriée
export const selectImg = (imgPng: ImageFormat, imgWebp: ImageFormat, imgJpg: ImageFormat): string => {
  // Si le navigateur client peut supporter WebP (prémisse côté serveur)
  if (imgWebp) {
    return imgWebp;
  }
  // Sinon, utilisez JPG si disponible
  if (imgJpg) {
    return imgJpg;
  }
  // En dernier recours, utilisez PNG ou une image par défaut
  return imgPng || defaultImg;
};

export default selectImg;
